const baseClasses = {
	header: {
		padding: '24px 26px',
		backgroundColor: '#1e283c',
		'@media (max-width:768px)': {
			width: '100%',
		}
	},
	title: {
		display: 'flex',
		justifyContent: 'space-between',
		padding: '5px 30px 5px 20px',
		fontWeight: '400',
		fontSize: '48px',
		fontFamily: 'TT-Interphases-Regular',
		fontStyle: 'normal',
		lineHeight: 1.3,
		letterSpacing: 'normal',
		marginLeft: '-20px',
		color: '#ffffff',
		'@media (max-width:768px)': {
			fontSize: '24px',
			padding: '0px 0px 10px 0px',
			justifyContent: 'left',
		}
	},
	eventsCard: {
		marginLeft: '10%',
		marginRight: '10%',
		marginBottom: '40px',
		marginTop: '40px',
		position: 'relative',
		overflow: 'clip',
		boxShadow: '0px 1px 20px 0px rgba(0,0,0,0.07), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.06)',
		'@media (max-width:768px)': {
			marginLeft: '0',
			marginRight: '0',
			marginTop: '0',
			marginBottom: '5%',
			borderRadius: 0,
		}
	},
	datePicker: {
		margin: '0px',
		backgroundColor: 'white',
		borderRadius: '4px',
		height :'40px',
		'& fieldset': {
			border: 'none',
		},
		'& input': {
			height: '40px',
			fontSize: '20px',
			fontFamily: 'TT-Interphases-Regular',
			padding: '0px 10px'
		},
		'@media (max-width:768px)': {
			width: '100%',
		},
	},
	checkboxOption: {
		'& span': {
			fontFamily: 'TT-Interphases-Regular',
			fontSize: '14px',
		},
	},
	mobileCheckboxOption: {
		'& span': {
			fontFamily: 'TT-Interphases-Regular',
		},
	},
	select: {
		backgroundColor: 'white',
		borderRadius: '4px',
		border: '1px solid black',
		height: '40px',
		lineHeight: '40px',
		margin: '0px',
		'& .MuiSelect-select': {
			fontFamily: 'TT-Interphases-Regular',
			fontSize: '20px',
		},
		'& div': {
			height: '40px'
		},
		'& div div': {
			display: 'flex',
			alignItems: 'center'
		},
		'& .MuiInputLabel-shrink': {
			display: 'none'
		},
		'& label': {
			transform: "translate(14px, 15px) scale(1)"
		},
		'& .MuiOutlinedInput-root': {
			'&.Mui-focused fieldset': {
				'& label': {
					display: 'none'
				}
			},
			'& fieldset': {
				display: 'none'
			}
		},
	},
	button: {
		width: '48%',
		height: '40px',
		fontFamily: 'TT-Interphases-Regular',
		fontStyle: 'bold',
		fontWeight: '700',
		fontSize: '12px',
		color: '#2850a0',
		borderRadius: '8px',
		backgroundColor: '#ffffff',
		'@media (max-width:768px)': {
			width: '60%',
			height: '30px',
		},
		'&:hover': {
			color: '#ffffff',
		},
	},
	mobileButtonsContainer: {
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	clearFilters: {
		color: '#FFFFFF !important',
		fontWeight: '700',
		fontSize: '12px',
		fontFamily: 'TT-Interphases-Regular',
		textDecoration: 'underline',
		cursor: 'pointer',
		padding: '8px 4px',
		textTransform: 'uppercase',
	},
	filterContainerTitle: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		width: '50%',
		color: '#ffffff',
		justifyContent: 'space-evenly',
		marginRight: '16px',
		'@media (max-width:768px)': {
			width: '100%',
			alignItems: 'left',
			marginRight: '0px',
			marginBottom: '16px !important',
		}
	},
	filterTitle: {
		fontSize: '22px',
		fontWeight: '700',
		fontStyle: 'normal',
		lineHeight: 'normal',
		letterSpacing: '-0.3px',
		fontFamily: 'TT-Interphases-Regular',
		'@media (max-width:768px)': {
			fontSize: '16px',
		},
	},
	filterDescription: {
		fontSize: '22px',
		fontStyle: 'normal',
		lineHeight: 1.3,
		letterSpacing: '-0.3px',
		textAlign: 'left',
		fontFamily: 'TT-Interphases-Regular',
		'@media (max-width:768px)': {
			fontSize: '16px',
			textAlign: 'center',
		}
	},
	filterItem: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		width: '50%',
		marginLeft: '0px',
		'@media (max-width:768px)': {
			width: '100%',
		}
	},
	filterDateItem: {
		width: '49%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
	},
	filterLabel: {
		textAlign: 'left',
		marginBottom: '2px',
		color: '#ffffff',
		fontFamily: 'TT-Interphases-Regular',
		fontSize: '14px',
	},
	filterButton: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'flex-end',
		width: '50%',
		marginRight: 0,
		'@media (max-width:768px)': {
			justifyContent: 'center',
		},
	},
	datesContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		width: '50%',
		marginRight: '16px',
		'@media (max-width:768px)': {
			width: '100%',
		},
	},
	filterCheckboxContainer: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		width: '50%',
		marginLeft: '0px',
		marginRight: '16px',
		'@media (max-width:768px)': {
			width: '100%',
		},
	},
	checkboxGroup: {
		padding: '4px 16px',
		backgroundColor: 'rgba(255, 255, 255, 0.71)',
		width: '100%',
		borderRadius: '3px',
		display: 'grid',
		gridTemplateColumns: {
			xs: 'repeat(2, 1fr)',
			sm: 'repeat(2, 1fr)',
		},
		gridTemplateRows: {
			sm: 'repeat(2, 1fr)',
			md: '1fr'
		},
		'@media (min-width:1200px)': {
			gridTemplateColumns: 'repeat(var(--options-count, 4), 1fr)',
		},
		'@media (min-width:550px) and (max-width:768px)': {
			gridTemplateColumns: 'repeat(var(--options-count, 4), 1fr)',
			gridTemplateRows: '1fr'
		},
	},
	cardsContainer: {
		display: 'grid',
		gridTemplateColumns: {
			xs: '1fr',
			sm: 'repeat(2, 1fr)',
			md: 'repeat(3, 1fr)',
			lg: 'repeat(4, 1fr)'
		},
		gridAutoRows: '1fr',
		rowGap: 3,
		columnGap: 2,
	},
	pagination: {
		marginTop: '16px',
		justifyItems: 'center',
	},
	noEvents: {
		padding: '24px 26px',
		fontSize: '22px',
		fontStyle: 'normal',
		textAlign: 'left',
		fontFamily: 'TT-Interphases-Regular',
		'& a': {
			color: '#1e283b',
			'&:checked': {
				color: '#1e283b',
			},
		},
	},
};

const dedicatedOverrides = {
	button: {
		...baseClasses.button,
		width: '30%',
	},
	filterContainerTitle: {
		display: 'flex',
		flexDirection: 'row',
		width: '100%',
		color: '#ffffff',
		justifyContent: 'space-between',
		'@media (max-width:768px)': {
			width: '100%',
			marginRight: '0px',
			marginBottom: '16px !important',
			flexDirection: 'column',
		}
	},
	filterDescription: {
		fontSize: '22px',
		fontStyle: 'normal',
		fontWeight: 'bold',
		lineHeight: 1.3,
		letterSpacing: '-0.3px',
		textAlign: 'left',
		color: '#ffffff',
		marginBottom: '4px',
		fontFamily: 'TT-Interphases-Regular',
		'a': {
			color: '#a0bee6',
		},
		'@media (max-width:768px)': {
			fontSize: '16px',
		}
	},
	filterDescriptionTitle: {
		fontSize: '18px',
		fontStyle: 'normal',
		lineHeight: 'normal',
		letterSpacing: '-0.3px',
		textAlign: 'left',
		color: '#ffffff',
		fontFamily: 'TT-Interphases-Regular',
		'@media (max-width:768px)': {
			fontSize: '16px',
		}
	},
};

const dedicatedClasses = { ...baseClasses, ...dedicatedOverrides };

export const getPortalClasses = (layout) => (
	layout === 'dedicated' ? dedicatedClasses : baseClasses
);
